import axios from 'axios';

const baseURL = `${process.env.REACT_APP_BASE_URL}/v1/api`

const api = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor 
api.interceptors.request.use(
  config => config,
  error => Promise.reject(error)
);

// Response interceptor (returns only response data)
api.interceptors.response.use(
  response => response.data,
  error => {
    // To handle global errors here
    return Promise.reject(
      error.response?.data || error.message || 'Unknown API error occurred'
    );
  }
);

export default api;